/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add-grey': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g _stroke="#B8BDC0" _fill="none" fill-rule="evenodd" stroke-linecap="square"><path pid="0" d="M5.594 11.046v-10M.594 6.046h10"/></g>'
  }
})
